
import React, { useState, useEffect } from 'react';
import './Faq.css'; 
import { initFacebookPixel } from '../facebookPixel';
const faqs = [
  {
    question: 'What will be coach to player ratio?',
    answer: 'For Badminton, Coach to player ratio will be 1:8.',
  },
  {
    question: 'When Summer camp will start and when it will end?',
    answer: 'Machaxi Summer Camp will start on April 1, 2025 and will end on May 31, 2025.',
  },
  {
    question: 'What are the batches available for Badminton?',
    answer: 'For Badminton, there are four batch timings:\n\n1. 9 AM - 10 AM\n2. 10 AM - 11 AM\n3. 3 PM - 4 PM\n4. 9 AM - 11 AM\n\nYou can opt for plans based on number of sessions during this camp.',
  },
  {
    question: 'Are there any early bird offer?',
    answer: 'Yes, there are early bird discounts available till March 30th. Please check our plan for the sport you want to enroll for.',
  },
  {
    question: 'What are the sports equipments and attire required?',
    answer: 'For Badminton, Racquet and non-marking badminton shoes are mandatory.',
  }
];


const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpand = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };
  document.querySelectorAll('.faq-header-item').forEach(item => {
    item.addEventListener('click', () => {
      const answer = item.nextElementSibling;
  
      // Toggle the "open" class on the answer
      answer.classList.toggle('open');
    });
  });
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="faq-container">
      <h2 className="faq-header">FAQ's</h2>
      <ul className="faq-list">
        {faqs.map((faq, index) => (
          <li key={index} className="faq-item">
            <div
              className="faq-header-item"
              onClick={() => handleExpand(index)}
            >
               <span className={`faq-toggle ${expandedIndex === index ? 'expanded' : ''}`}>
                {expandedIndex === index ? '▾' : '▸'}
              </span>
              <span className="faq-question">{faq.question}</span>
             
            </div>
            <div className={`faq-answer ${expandedIndex === index ? 'open' : ''}`}>
              <pre>{faq.answer}</pre>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
